<template>
	<div v-if="!IsFront" class="header">
		<div class="header-left">
			<el-checkbox @change="getData()" v-model="mynews" label="我的资讯" border class="mynewsbtn" />
			<el-checkbox @change="getData()" v-model="allschnews" label="所有院校资讯" border class="mynewsbtn" />
			<el-input class="mynewsbtn" v-model="newstitle" style="width: 240px" placeholder="请输入资讯关键字" />
			<el-button type="primary" class="mynewsbtn" @click="getData()">查询</el-button>
		</div>
		<div class="header-right">
			<el-button type="primary" @click="AddNews()">增加资讯</el-button>
		</div>
	</div>
	<el-table :data="tableData" :height="tableHeight">
		<el-table-column v-if="!IsFront" prop="SchoolName" label="院校名称" width="200">
		</el-table-column>
		<el-table-column prop="name" label="资讯标题" width="">
			<template #default="scope">
				<div style="text-align: left;"><el-link :href="scope.row.WebUrl"
						target="_blank">{{scope.row.Title}}</el-link></div>
			</template>
		</el-table-column>
		<el-table-column prop="PublishDt" label="发布日期" width="110">
			<template #default="scope">
				{{ scope.row.PublishDt ? scope.row.PublishDt.substring(0, 10) : ''}}
			</template>
		</el-table-column>
		<el-table-column v-if="!IsFront" prop="Enable" label="状态" width="100">
			<template #default="scope">
				{{getStatus(scope.row.Enable)}}
			</template>
		</el-table-column>
		<el-table-column v-if="!IsFront" prop="" label="操作" width="150">
			<template #default="scope">
				<el-button :title="scope.row.MngIDAdd !== userID ? '仅能操作自己的资讯' : ''"
					:disabled="scope.row.MngIDAdd !== userID" size="small"
					@click="EditNews(scope.row.ID)">编辑</el-button>
				<el-popconfirm title="确定要删除这条资讯吗？" confirm-button-text="确定" cancel-button-text="取消" icon-color="#F56C6C"
					@confirm="confirmDelete(scope.row)">
					<template #reference>
						<el-button :title="scope.row.MngIDAdd !== userID ? '仅能操作自己的资讯' : ''"
							:disabled="scope.row.MngIDAdd !== userID" size="small" type="danger">删除</el-button>
					</template>
				</el-popconfirm>
			</template>
		</el-table-column>
	</el-table>
	<el-pagination style="margin-top: 20px;" align='center' @size-change="handleSizeChange"
		@current-change="handleCurrentChange" :current-page="parm.pageIndex" :page-sizes="[10, 20, 30]"
		:page-size="parm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="parm.rowCount">
	</el-pagination>

	<el-dialog :style="{width:'1000px', minHeight: '500px' }" v-model="showEditSchNews" :title="SchName+'_编辑资讯'"
		width="700">
		<!-- 使用容器包裹 -->
		<div class="form-container">
			<div class="form-row">
				<label class="form-label">资讯标题</label>
				<el-input v-model="parm.Title" class="form-input"></el-input>
			</div>

			<div class="form-row">
				<label class="form-label">资讯网址</label>
				<el-input v-model="parm.WebUrl" class="form-input"></el-input>
			</div>

			<div class="form-row">
				<label class="form-label">所属省份</label>
				<el-select v-model="parm.AreaID" placeholder="请选择省份" class="form-input">
					<el-option v-for="item in options" :key="item.ID" :label="item.Name" :value="item.ID" />
				</el-select>
			</div>

			<div class="form-row">
				<label class="form-label">资讯类型</label>
				<el-radio-group v-model="parm.Enable" class="form-input">
					<el-radio :label="0" border>草稿</el-radio>
					<el-radio :label="1" border>发布</el-radio>
				</el-radio-group>
			</div>

			<div class="form-row">
				<label class="form-label">发布日期</label>
				<!-- <el-date-picker v-model="parm.PublishDt" type="datetime" placeholder="选择日期和时间" class="form-input" /> -->
				<el-date-picker v-model="parm.PublishDt" type="date" value-format="YYYY-MM-DD" placeholder="选择日期"
					:size="size" />
			</div>

			<div class="form-row">
				<div class="form-submit">
					<el-button type="primary" @click="SaveData()">保存</el-button>
				</div>
			</div>
		</div>
	</el-dialog>

</template>

<script>
	export default {
		props: {
			IsFront: {
				type: Boolean,
				default: false,
				required: false,
			},
			SchID: {
				type: String,
				default: '',
				required: false,
			},
			SchName: {
				type: String,
				default: '',
				required: false,
			},
		},
		data() {
			return {
				userID: "", //this.$store.getters.getUserMdl().ID,
				showEditSchNews: false,
				mynews: false,
				allschnews:false,
				newstitle: '',
				parm: {
					ID: "",
					SchID: this.SchID,
					Title: "",
					WebUrl: "",
					AreaID: "0",
					PublishDt: this.getTodayString(), // 直接设置为当前时间
					Enable: 1,
					pageSize: 20,
					rowCount: 0,
					pageIndex: 1,
				},
				tableData: [],
				options: [{
						value: '0',
						label: '全国',
					},
					{
						value: '11',
						label: '北京',
					},
					{
						value: '12',
						label: '天津',
					},
					{
						value: '13',
						label: '河北',
					},
					{
						value: '14',
						label: '山西',
					}
				]
			}
		},
		computed: {
			tableHeight() {
				return this.IsFront ? null : 300;
			}
		},
		// methods: {
		// 	EditNews() {
		// 		this.showEditSchNews = true;
		// 		this.parm.ID = "";
		// 	},
		// 	EditNews(id) {
		// 		this.showEditSchNews = true;
		// 		this.$http.get("/SchoolNews/GetModel", {
		// 			ID: id,
		// 		}).then(res => {
		// 			this.parm.ID = res.data.ID;
		// 		    this.parm.Title = res.data.Title;
		// 			this.parm.WebUrl = res.data.WebUrl;
		// 			this.parm.AreaID = res.data.AreaID;
		// 			this.parm.Enable = res.data.Enable;
		// 			this.parm.PublishDt = res.data.PublishDt;

		// 		});
		// 	},
		// 	//获取资讯列表数据
		// 	getData() {
		// 		this.$http.get("/SchoolNews/GetPageList", {
		// 			schID: this.SchID,
		// 			page:this.parm.pageIndex,
		// 			rows:this.parm.pageSize
		// 		}).then(res => {
		// 		    this.tableData = res.data.List;
		// 			this.parm.rowCount= res.data.RowCount;

		// 		});
		// 	},
		// 	//保存资讯
		// 	SaveData() {
		// 		let title = this.parm.Title;
		// 		if (title.trim() == '') {
		// 			this.$message.warning('请填写资讯标题！');
		// 			return;
		// 		}
		// 		let webUrl = this.parm.WebUrl;
		// 		if (title.trim() == '') {
		// 			this.$message.warning('请填写资讯网址！');
		// 			return;
		// 		}
		// 		let model = this.parm;
		// 		debugger;
		// 		let url = "/SchoolNews/SaveNewsMdl";
		// 		if(this.parm.ID > 0){
		// 			url = "/SchoolNews/EditNewsMdl";
		// 		}
		// 		this.$http.post(url, model, true).then((res) => {
		// 			if (res.code == 1) {
		// 				this.$message.success('保存成功');
		// 				this.showEditSchNews = false;
		// 				this.getData();
		// 			} else {
		// 				this.$message.error(res.msg);
		// 			}
		// 		});
		// 	},
		// },
		methods: {
			// 获取今天日期,如果需要特定格式
			getTodayString() {
				const today = new Date();
				const year = today.getFullYear();
				const month = String(today.getMonth() + 1).padStart(2, '0');
				const day = String(today.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			getStatus(val) {
				if (val == 0) {
					return "草稿";
				} else {
					return "已发布";
				}
			},
			// 新增资讯
			AddNews() {
				this.resetForm(); // 重置表单
				this.showEditSchNews = true;
				this.parm.ID = 0;
				this.parm.SchID = this.SchID;
			},

			// 编辑资讯
			EditNews(id) {
				this.showEditSchNews = true;
				this.$http.get("/SchoolNews/GetModel", {
					ID: id,
				}).then(res => {
					this.parm.ID = res.data.ID;
					this.parm.Title = res.data.Title;
					this.parm.WebUrl = res.data.WebUrl;
					this.parm.AreaID = res.data.AreaID;
					this.parm.Enable = res.data.Enable;
					this.parm.PublishDt = res.data.PublishDt;
				});
			},

			// 重置表单
			resetForm() {
				this.parm = {
					ID: "",
					SchID: this.SchID,
					Title: "",
					WebUrl: "",
					AreaID: "0", // 每次重置都设置为"全国"
					PublishDt: this.getTodayString(), // 重置为当前时间
					Enable: 1,
					pageSize: 20,
					//rowCount: 0,
					pageIndex: 1,
				};
			},

			// 保存资讯
			SaveData() {
				// 验证逻辑
				let title = this.parm.Title;
				if (title.trim() == '') {
					this.$message.warning('请填写资讯标题！');
					return;
				}
				let webUrl = this.parm.WebUrl;
				if (webUrl.trim() == '') { // 这里应该是 webUrl，不是 title
					this.$message.warning('请填写资讯网址！');
					return;
				}
				let publishDt = this.parm.PublishDt;
				if (publishDt.trim() == '') { // 这里应该是 webUrl，不是 title
					this.$message.warning('请填写发布日期！');
					return;
				}

				let model = this.parm;
				let url = this.parm.ID > 0 ? "/SchoolNews/EditNewsMdl" : "/SchoolNews/SaveNewsMdl";

				this.$http.post(url, model, true).then((res) => {
					if (res.code == 1) {
						this.$message.success('保存成功');
						this.showEditSchNews = false;
						this.getData();
					} else {
						this.$message.error(res.msg);
					}
				});
			},

			// 确认删除
			confirmDelete(row) {
				this.$http.post(`/SchoolNews/DeleteNewsMdl?ID=${row.ID}`).then((res) => {
					if (res.code == 1) {
						this.$message.success('保存成功');
						this.showEditSchNews = false;
						this.getData();
					} else {
						this.$message.error(res.msg);
					}
				});
			},

			// 获取资讯列表
			getData() {
				let mngID = "";
				let schid = this.SchID;
				if (this.mynews) {
					//登录ID
					mngID = this.userID;
				}
				if(this.allschnews){
					schid = "";
				}
				this.$http.get("/SchoolNews/GetPageList", {
					schID: schid,
					mngID: mngID,
					isFront: this.IsFront,
					title: this.newstitle,
					page: this.parm.pageIndex,
					rows: this.parm.pageSize
				}).then(res => {
					this.tableData = res.data.List;
					if (this.IsFront) {
						this.tableData = res.data.List.filter(c => c.Enable == 1);
					}
					this.parm.rowCount = res.data.RowCount;
				});
			},

			// 获取省份列表
			getAreaList() {
				this.$http.get("/Sys/Area/GetProvinceList", {}).then(res => {
					// 在接收到的数据开头添加"全国"选项
					const nationalOption = {
						ID: "0",
						PID: "0",
						Name: "全国"
					};

					// 使用 unshift 添加到数组开头
					res.data.unshift(nationalOption);
					this.options = res.data;
				});
			},

			// 分页方法
			handleSizeChange(val) {
				this.parm.pageSize = val;
				this.getData();
			},

			handleCurrentChange(val) {
				this.parm.pageIndex = val;
				this.getData();
			}
		},
		created() {
			if (!this.IsFront) {
				this.userID = this.$store.getters.getUserMdl().ID;
			}
			this.getData();
			this.getAreaList();
		}
	}
</script>

<style scoped>
	.mynewsbtn {
		margin-right: 10px;
	}

	.header {
		display: flex;
		justify-content: space-between;
		margin-top: -10px;
		margin-bottom: 10px;
	}

	.header-left {
		display: flex;
		align-items: center;
	}

	.header-right {
		display: flex;
		align-items: center;
	}

	.form-container {
		display: flex;
		flex-direction: column;
		gap: 16px;
		margin-right: 20px;
		/* 行间距 */
	}

	.form-row {
		display: flex;
		align-items: center;
		/* 垂直居中 */
		min-height: 40px;
		/* 最小高度 */
	}

	.form-label {
		width: 100px;
		/* 固定标签宽度 */
		text-align: right;
		/* 标签右对齐 */
		padding-right: 12px;
		/* 标签和输入框之间的间距 */
		flex-shrink: 0;
		/* 防止标签被压缩 */
	}

	.form-input {
		flex: 1;
		/* 输入区域占满剩余空间 */
		min-width: 0;
		/* 防止flex item溢出 */
	}

	/* 提交按钮单独处理 */
	.form-submit {
		margin-left: 112px;
		/* 100px标签宽度 + 12px间距 */
		padding-top: 8px;
	}
</style>